import { Box, Tooltip } from '@mui/material';
import { ReactNode } from 'react';

export function TextBubbleMarker({
  index,
  positionPx,
  pillWidth,
  top,
  bottom,
  contentTitle: contentTitle,
  tooltipTitle,
}: {
  index: number;
  positionPx: number;
  pillWidth: number;
  top: number;
  bottom: number;
  contentTitle: ReactNode;
  tooltipTitle: ReactNode;
}) {
  const FONT_SIZE = 12;
  const pillHeight = 18;

  return (
    <g key={index} data-qa-element-id={`marker_${index}`}>
      <line
        x1={positionPx}
        x2={positionPx}
        y1={top + 18}
        y2={bottom}
        stroke="var(--mui-palette-text-secondary)"
        strokeWidth={2}
      />
      <foreignObject x={positionPx - pillWidth / 2} y={top} width={pillWidth} height={pillHeight + 8}>
        <Tooltip
          title={tooltipTitle}
          slotProps={{ tooltip: { sx: { margin: '5px 0px !important', padding: '4px' } } }}
          placement="top"
          arrow
        >
          <Box
            style={{
              width: pillWidth,
              height: pillHeight,
              borderRadius: '8px',
              border: '2px solid  var(--mui-palette-text-secondary)',
              background: '#fff',
              fontSize: FONT_SIZE,
              color: '#555',
              pointerEvents: 'auto',
              lineHeight: `1`,
            }}
          >
            {contentTitle}
          </Box>
        </Tooltip>
      </foreignObject>
    </g>
  );
}
